import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
// Actions
import {
  reportsMainGenerateReportProgress,
  reportsMainGenerateReportUpdate
} from 'Redux/actions';

import {
  getTimeZone,
  getCategoryFilter,
  handleAsyncReport,
  baseReportConditions,
  generateReportInstance,
  isJsonFormat
} from 'Modules/reports/views/main/components/reportsTab/helper';
import {getAbbvTimezone} from "Components/uiControls/Timezone/tools";

function* getDriverCoachingReport(report, page, rowsPerPage, sortField, sortOrder, requestFlag) {
  const { timeZone , sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath } = report;
  const {
    filterType,
    filterArray,
    startRange,
    endRange,
    unitsSelected,
    otherFilters,
    accumulateData = true,
    dates
  } = report.filters
  const baseConditionsQuery = baseReportConditions({
    report,
    name,
    dataResultPath,
    timeZone,
    delayed,
    unitsSelected,
    timeframeName,
    filterType,
    filterArray,
    categoryName,
    startRange,
    endRange,
    dates
  })
  try {
    let payload = {
      conditions: {
        ...baseConditionsQuery,
        stringValues: {
          values: otherFilters.eventTypes ? otherFilters.eventTypes?.map(event => event.name).filter(evnt => evnt !== '') : []
        },
        sortField: {
          field: sortField || "deviceId",
          order: sortOrder === 'desc' ? 'DESC' : 'ASC'
        }
      },
      limit: rowsPerPage,
      offset: page
    };

    if (report.export) {
      payload = {
        ...payload,
        limit: isJsonFormat(report?.exportType, dataResultPath)? rowsPerPage : 5000,
        offset: isJsonFormat(report?.exportType, dataResultPath)? page : 1,
        conditions: {
          ...payload.conditions,
          exportOptions: {
            sendByEmail,
            emailsTo,
            format: {
              fileFormat: report?.exportType || "json",
              formatOptions: "{\"addPagination\": \"true\", \"addLogo\": \"true\", \"addLine\": \"true\"}",
              durationFormat: report?.durationFormat
            },
            culture: report.lang,
            timeZone: getTimeZone(timeZone),
            folderName: "px-customer-reports",
            filePrefixName: "driverCoachingReport",
            columns: [
              {
                "column": "eventId",
                "header": "Event Id",
              },
              {
                "column": "driverName",
                "header": "Driver"
              },
              {
                "column": "driverExternalId",
                "header": "Driver ID"
              },
              {
                "column": "vehicle",
                "header": "Vehicle"
              },
              {
                "column": "date",
                "header": "Date"
              },
              {
                "column": "time",
                "header": `${report?.exportType === "csv" ? `Time (${getAbbvTimezone(timeZone)})` : `Time`}`
              },
              {
                "column": "event",
                "header": "Event"
              },
              {
                "column": "status",
                "header": "Status"
              },
              {
                "column": "notes",
                "header": "Notes"
              },
              {
                "column": "reviewedOn",
                "header": `${report?.exportType === "csv" ? `Reviewed On (${getAbbvTimezone(timeZone)})` : `Reviewed On`}`
              }


            ]
          }
        }
      }
    }
    let data = yield call(
      clientQuery,
      `query getDriverCoachingReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getDriverCoachingReport (conditions: $conditions, limit: $limit, offset: $offset) {
          ${ generateReportInstance(report.export, dataResultPath, report.exportFromTable)?
            `reportInstanceId`
          :`
            items {
              recordInfo {
                entityId
                entityLabel
                tagId
                startDate
                endDate
                recordType
                groupLabel
                groupIndex
                groupTotal
                groupTagColor
              }
              recordDetail {
                eventId
                driverName
                driverExternalId
                tagLabel
                vehicle
                date
                time
                event
                unitTime
                status
                notes
                reviewedOn
                noData
              }
            }
            total
            limit
            offset
            category
        `}
        }
        
      }`,
      payload ,
      endpoints.GRAPHQL_PX_REPORTING,
    );
    yield handleAsyncReport(report, data, accumulateData);

  } catch (exc) {
    ExceptionManager(exc, 'reports/driverCoachingReport', 'getDriverCoachingReport');
    report.loading = false
    yield put(reportsMainGenerateReportProgress(report))
    if (!requestFlag) {
      let flag = true
      yield put(reportsMainGenerateReportUpdate(report, page, rowsPerPage, sortField, sortOrder, flag))
    } else {
      report.loading = false
      yield put(reportsMainGenerateReportProgress(report))
    }
  }
}


export default getDriverCoachingReport;
